<template>
  <div>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="7">
          <el-input v-model="queryTechnicalInfo.searchFileName" placeholder="请输入技术文档名称" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="2.5">
          <el-button type="primary" @click="addTechnical">添加技术文档</el-button>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="openImgDialog">添加横幅图</el-button>
        </el-col>
      </el-row>

      <!-- 表格区域 -->
      <el-table :data="technicalList" style="width: 100%" border stripe>
        <el-table-column type="index" />
        <el-table-column prop="docTitle" label="技术文档名称"  />
        <el-table-column prop="docDesc" label="文档描述"  />
        <el-table-column prop="author" label="发布人" width="250" />
        <el-table-column prop="uploadTime" label="发布时间" width="250"/>
        <el-table-column label="操作" width="180">
          <template #default="scope">
            <!-- 修改按钮 -->
            <el-tooltip
              effect="dark"
              content="修改"
              placement="top"
              :enterable="false"
            >
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="handleEdit(scope.$index, scope.row)"></el-button>
            </el-tooltip>
            <!-- 删除按钮 -->
            <el-tooltip
              effect="dark"
              content="删除"
              placement="top"
              :enterable="false"
            >
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleDelete(scope.$index, scope.row)"></el-button>
            </el-tooltip>
            <!-- 下载按钮 -->
            <el-tooltip
              effect="dark"
              content="下载"
              placement="top"
              :enterable="false"
            >
              <el-button type="success" icon="el-icon-download" size="mini" @click="handleDownload(scope.$index, scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryTechnicalInfo.pageNum"
        :page-sizes="[5, 8, 10, 20]"
        :page-size="queryTechnicalInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

      <!-- 添加横幅图dialog -->
      <el-dialog
        title="技术文档横幅图"
        :visible.sync="technicalImgDialogVisible"
        width="30%"
        :before-close="closeTechnicalImgDialog"
        center
      >
        <el-upload
          action="string"
          :http-request="settingTopBackground"
          accept=".png,.jpg,.jpeg"
          :show-file-list="false">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <div class="topBackgroundImg">
          <img :src="topBackgroundImg" alt="">
        </div>
        <div class="uploadTip">建议上传相同比例的横幅图</div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { getTechDocList, deleteTechnical, settingTopBackground, getTopBackground, downloadResource } from '@/api/editTechnical'
export default {
  data () {
    return {
      // 获取技术文档列表的参数对象
      queryTechnicalInfo: {
        searchFileName: '', // 搜索名称
        pageNum: 1, // 当前的页数
        pageSize: 10 // 当前显示的多少条数据
      },
      // 技术文档列表
      technicalList: [],
      // 总条数
      total: 0,
      technicalImgDialogVisible: false,
      topBackgroundImg: '' // 横幅图图片
    }
  },
  created () {
    const pageNum = Number(this.$route.query.pageNum)
    const pageSize = Number(this.$route.query.pageSize)
    if (Number.isInteger(pageNum) && pageNum > 0) this.queryTechnicalInfo.pageNum = pageNum
    if (Number.isInteger(pageSize) && pageSize > 0) this.queryTechnicalInfo.pageSize = pageSize
    if (typeof this.$route.query.searchFileName === 'string') {
      this.queryTechnicalInfo.searchFileName = this.$route.query.searchFileName
    }
    // 获取技术文档列表
    this.getTechnicalList()
  },
  methods: {
    // 获取技术文档列表
    getTechnicalList () {
      getTechDocList(this.queryTechnicalInfo).then(res => {
        if (res.code == 0) {
          const list = res.data.rows.filter(item => {
            item.author = '智会云科技'
            return item
          })
          this.technicalList = list
          this.total = res.data.total
        } else {
          this.$message.error('获取技术文档列表失败！')
        }
      })
    },
    // 关键字搜索
    search () {
      this.queryTechnicalInfo.pageNum = 1
      this.getTechnicalList()
    },
    // 点击添加技术文档 跳转路由
    addTechnical () {
      this.$router.push({ path: '/management/editTechnicalItem' })
    },
    // 点击编辑
    handleEdit (index, row) {
      // this.$router.push({path:'/management/editTechnicalItem',query:{id: row.id}});
      this.$router.push({
        name: 'editTechnicalItem',
        params: { id: row.id },
        query: {
          pageNum: this.queryTechnicalInfo.pageNum,
          pageSize: this.queryTechnicalInfo.pageSize,
          searchFileName: this.queryTechnicalInfo.searchFileName || undefined
        }
      })
    },
    // 点击删除
    handleDelete (index, row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTechnical(row.id).then(res => {
          if (res.code == 0) {
            this.$message.success('删除技术文档成功！')
            this.getTechnicalList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 点击下载
    handleDownload (index, row) {
      downloadResource(row.id).then(res => {
        const blob = res instanceof Blob ? res : new Blob([res])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', row.fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      })
    },
    // 分页功能下拉选择器触发
    handleSizeChange (newSize) {
      this.queryTechnicalInfo.pageSize = newSize
      this.queryTechnicalInfo.pageNum = 1
      // 重新获取数据
      this.getTechnicalList()
    },
    // 监听页码值改变
    handleCurrentChange (newSize) {
      this.queryTechnicalInfo.pageNum = newSize
      // 重新获取数据
      this.getTechnicalList()
    },
    // 打开横幅图dialog
    openImgDialog () {
      this.technicalImgDialogVisible = true
      this.getTopBackground()
    },
    // 添加横幅图dialog关闭
    closeTechnicalImgDialog () {
      this.technicalImgDialogVisible = false
    },
    // 获取技术文档横幅图图片
    getTopBackground () {
      getTopBackground().then(res => {
        if (res.code == 0) {
          this.topBackgroundImg = res.data.value
        } else {
          this.$message.error('获取技术文档横幅图失败！')
        }
      })
    },
    // 添加或编辑技术文档横幅图图片
    settingTopBackground (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      settingTopBackground(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.getTopBackground()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.topBackgroundImg{
  width: 100%;
  height: 180px;
  border: 1px solid;
  margin-top: 20px;
  img{
    width: 100%;
    height: 100%;
  }
}

.uploadTip{
  font-size: 12px;
  color: red;
  margin-top: 5px;
}
</style>
